<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Unidad principal de la estructura organizativa. Representa una razón social distinta con información
                fiscal y legal propia. Se debe crear una nueva compañía cuando se trata de una entidad financiera o
                legal diferente dentro del ecosistema AVE.</p>
            </div>
          </mat-menu>


          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Compañias
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina las <b>compañias</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Compañías</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Show filters button -->
          <!-- <button
            mat-stroked-button
            color="primary"
            (click)="sidenav.toggle()"
            matTooltip="Mostrar filtros"
          >
            <mat-icon svgIcon="filter_list"></mat-icon>
            <span>Filtrar por</span>
          </button> -->
          <!-- Add button (only icon) -->
          <button *canPermissionsOnly="PERMISSIONS.CREATE" mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn">
              <!-- Logo -->
              <ng-container matColumnDef="logo">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Logo
                </th>
                <td mat-cell *matCellDef="let company" class="text-center">
                  <div class="flex justify-center">
                    <div *ngIf="company.logoUrl; else noLogo"
                         class="w-12 h-12 rounded border-2 border-gray-200 overflow-hidden">
                      <img
                        [src]="company.logoUrl"
                        [alt]="'Logo de ' + company.name"
                        class="w-full h-full object-contain"
                        (error)="$event.target.style.display='none'"
                      >
                    </div>
                    <ng-template #noLogo>
                      <div class="w-12 h-12 rounded border-2 border-dashed border-gray-300 flex items-center justify-center">
                        <mat-icon class="text-gray-400 text-sm">business</mat-icon>
                      </div>
                    </ng-template>
                  </div>
                </td>
              </ng-container>

              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Nombre
                </th>
                <td mat-cell *matCellDef="let company" class="text-sm uppercase leading-tight">
                  <div *ngIf="getCode(company) as code">
                    <b class="f-12">{{ code }}</b>
                  </div>
                  {{ company.name }}
                </td>
              </ng-container>

              <!-- Tipo -->
              <ng-container matColumnDef="RTN">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  RTN
                </th>
                <td mat-cell *matCellDef="let company" class="text-sm uppercase">
                  {{ company.NIT }}
                </td>
              </ng-container>
              <!-- Estado (mat-slide-toggle) -->
              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef>
                  Estado
                </th>
                <td mat-cell *matCellDef="let company">
                  <mat-slide-toggle [checked]="company.statusId === 1"
                    (change)="onStatusChange($event.checked, company)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let company" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button *canPermissionsOnly="PERMISSIONS.UPDATE" mat-menu-item (click)="openEditModal(company)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button *canPermissionsOnly="versionConfigPermissions.VIEW" mat-menu-item (click)="openVersionConfig(company)">
                      <mat-icon svgIcon="heroicons_outline:tag"></mat-icon>
                      <span>Configuración de versiones</span>
                    </button>
                    <button *canPermissionsOnly="formConfigPermissions.VIEW" mat-menu-item (click)="openFormConfig(company)">
                      <mat-icon svgIcon="heroicons_outline:adjustments-horizontal"></mat-icon>
                      <span>Configuración de Formularios</span>
                    </button>
                    <button *canPermissionsOnly="userFieldsConfigPermissions.VIEW" mat-menu-item (click)="openFormConfigMaster(company)">
                      <mat-icon svgIcon="heroicons_outline:adjustments-horizontal"></mat-icon>
                      <span>Configuración de campos de usuario</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="openLogoPreviewModal(company)" *ngIf="(PERMISSIONS.VIEW | hasPermission) && (company.logoUrl)">
                      <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
                      <span>Ver Logo</span>
                    </button>
                    <button *canPermissionsOnly="companyLogoPermissions.UPDATE" mat-menu-item (click)="openLogoUpdateModal(company)">
                      <mat-icon svgIcon="heroicons_outline:photo"></mat-icon>
                      <span>{{ company.logoUrl ? 'Actualizar Logo' : 'Agregar Logo' }}</span>
                    </button>
                    <button *canPermissionsOnly="PERMISSIONS.AUDIT_LOG" mat-menu-item (click)="openAuditLog(company)">
                      <mat-icon>history</mat-icon>
                      <span>Ver log de modificaciones</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button *canPermissionsOnly="PERMISSIONS.DELETE" mat-menu-item (click)="openDeleteDialog(company)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900">
              </tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageIndex]="pageIndex" [pageSize]="pageSize" (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-xl font-bold mb-4 px-6 py-4 border-b">Nuevo Registro</h2>
      <mat-dialog-content class="overflow-y-auto max-h-full">
        <mat-tab-group class="mb-4">
          <mat-tab label="Datos Generales">
            <div class="py-6">
              <form #createForm="ngForm" class="space-y-8 flex flex-col">
              <app-form-section title="Información Básica" icon="business" iconColor="blue">
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                  <mat-form-field  class="w-full">
                    <mat-label>Nombre Legal</mat-label>
                    <input matInput [(ngModel)]="currentCreateCompany.name" name="name" required />
                    <mat-error *ngIf="!currentCreateCompany.name">Este campo es requerido</mat-error>
                  </mat-form-field>
                  <mat-form-field  class="w-full">
                    <mat-label>Nombre Comercial</mat-label>
                    <input matInput [(ngModel)]="currentCreateCompany.tradeName" name="tradeName" />
                  </mat-form-field>
                  <mat-form-field  class="w-full">
                    <mat-label>RTN</mat-label>
                    <input matInput [(ngModel)]="currentCreateCompany.NIT" name="NIT" required />
                    <mat-error *ngIf="!currentCreateCompany.NIT">Este campo es requerido</mat-error>
                  </mat-form-field>
                </div>
              </app-form-section>
              <app-form-section title="Póliticas comerciales" icon="currency_exchange" iconColor="green">
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
                  <div class="w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Lista de Precios</label>
                    <ng-select [(ngModel)]="currentCreateCompany.priceListId" [items]="priceList" bindLabel="name"
                      bindValue="_id" [searchable]="true" placeholder="Seleccione una lista de precios" name="priceListId"
                      [appendTo]="'body'" class="w-full">
                      <ng-template ng-label-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Lista de Descuentos</label>
                    <ng-select [(ngModel)]="currentCreateCompany.discountListId" [items]="discountList" bindLabel="name"
                      bindValue="_id" [searchable]="true" placeholder="Seleccione un precio de descuento"
                      name="discountListId" [appendTo]="'body'" class="w-full">
                      <ng-template ng-label-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Moneda</label>
                    <ng-select [(ngModel)]="currentCreateCompany.currencyBaseId" [items]="currencyList" bindLabel="name"
                      bindValue="_id" [searchable]="true" placeholder="Seleccione una tasa de cambio"
                      name="currencyBaseId" [appendTo]="'body'" class="w-full">
                    </ng-select>
                  </div>
                  <div class="grid gap-4 grid-cols-1 md:grid-cols-2">
                  <mat-form-field  class="w-full">
                    <mat-label>Máx. carácteres en series de numeración de documentos</mat-label>
                    <input type="number" matInput [(ngModel)]="currentCreateCompany.emissionPointSeriesLength"
                      name="emissionPointSeriesLength" min="0" placeholder="20" />
                    <mat-hint>0 = ilimitado, por defecto 20 caracteres</mat-hint>
                  </mat-form-field>
                  <mat-form-field  class="w-full" matTooltip="Define la cantidad máxima de dígitos que puede tener la numeración de los documentos" matTooltipPosition="above">
                    <mat-label># caracteres en la numeración de rangos</mat-label>
                    <input type="number" matInput [(ngModel)]="currentCreateCompany.documentNumberLength"
                      name="documentNumberLength" min="1" max="12" placeholder="8" #documentNumberLength="ngModel"/>
                      <mat-error *ngIf="documentNumberLength.errors?.['min'] || documentNumberLength.errors?.['max']">
                        Solo se aceptan valores entre 1 y 12
                      </mat-error>
                  </mat-form-field>
                  </div>
                  <div class="w-full">
                    <app-toggle-option
                      title="Bonificación en totales"
                      description="¿Se incluye valor de Bonificación en totales?"
                      icon="money"
                      iconColor="purple"
                      [(ngModel)]="currentCreateCompany.includeBonusInTotals"
                      name="includeBonusInTotals">
                    </app-toggle-option>
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Precio de la bonificación</label>
                    <ng-select
                      [(ngModel)]="currentCreateCompany.bonusPriceBehavior"
                      [items]="bonusPriceBehaviorOptions"
                      bindLabel="label"
                      bindValue="value"
                      placeholder="Seleccione un comportamiento"
                      name="bonusPriceBehavior"
                      class="w-full"
                      [disabled]="!currentCreateCompany.includeBonusInTotals">
                    </ng-select>
                  </div>
                </div>
                
              </app-form-section>
              
            <app-form-section title="Configuración de decimales" icon="calculate" iconColor="green">
              <div class="grid gap-6 grid-cols-1 md:grid-cols-3">
            
                <!-- Precios -->
                <mat-form-field class="w-full" matTooltip="# de decimales a mostrar para precios" matTooltipPosition="above">
                  <mat-label># de decimales a mostrar para precios</mat-label>
                  <input type="number" matInput [(ngModel)]="currentCreateCompany.numberOfDecimals" name="numberOfDecimals" min="0"
                    step="1" #numberOfDecimals="ngModel" />
                  <mat-error *ngIf="numberOfDecimals?.model < 0">
                    No se aceptan números negativos
                  </mat-error>
                </mat-form-field>
            
                <mat-form-field class="w-full" matTooltip="# de decimales para calcular precios" matTooltipPosition="above">
                  <mat-label># de decimales para calcular precios</mat-label>
                  <input type="number" matInput [(ngModel)]="currentCreateCompany.priceDecimalsWork" name="priceDecimalsWork"
                    min="0" step="1" #priceDecimalsWork="ngModel" />
                  <mat-error *ngIf="priceDecimalsWork?.model < 0">
                    No se aceptan números negativos
                  </mat-error>
                </mat-form-field>
            
                <!-- Stock -->
                <mat-form-field class="w-full" matTooltip="# de decimales a mostrar para stock" matTooltipPosition="above">
                  <mat-label># de decimales a mostrar para stock</mat-label>
                  <input type="number" matInput [(ngModel)]="currentCreateCompany.stockDecimalsDisplay" name="stockDecimalsDisplay"
                    min="0" step="1" #stockDecimalsDisplay="ngModel" />
                  <mat-error *ngIf="stockDecimalsDisplay?.model < 0">
                    No se aceptan números negativos
                  </mat-error>
                </mat-form-field>
            
                <mat-form-field class="w-full" matTooltip="# de decimales para calcular stock" matTooltipPosition="above">
                  <mat-label># de decimales para calcular stock</mat-label>
                  <input type="number" matInput [(ngModel)]="currentCreateCompany.stockDecimalsWork" name="stockDecimalsWork"
                    min="0" step="1" #stockDecimalsWork="ngModel" />
                  <mat-error *ngIf="stockDecimalsWork?.model < 0">
                    No se aceptan números negativos
                  </mat-error>
                </mat-form-field>
            
                <!-- Pagos -->
                <mat-form-field class="w-full" matTooltip="# de decimales a mostrar para pagos" matTooltipPosition="above">
                  <mat-label># de decimales a mostrar para pagos</mat-label>
                  <input type="number" matInput [(ngModel)]="currentCreateCompany.payDecimalView" name="payDecimalView" min="0"
                    step="1" #payDecimalView="ngModel" />
                  <mat-error *ngIf="payDecimalView?.model < 0">
                    No se aceptan números negativos
                  </mat-error>
                </mat-form-field>
            
                <mat-form-field class="w-full" matTooltip="# de decimales para calcular pagos" matTooltipPosition="above">
                  <mat-label># de decimales para calcular pagos</mat-label>
                  <input type="number" matInput [(ngModel)]="currentCreateCompany.payDecimalWork" name="payDecimalWork" min="0"
                    step="1" #payDecimalWork="ngModel" />
                  <mat-error *ngIf="payDecimalWork?.model < 0">
                    No se aceptan números negativos
                  </mat-error>
                </mat-form-field>
            
              </div>
            </app-form-section>

              <app-form-section title="Configuración de Negocio" icon="settings" iconColor="purple">
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                  <mat-form-field  class="w-full">
                    <mat-label># Aprobadores de nuevos clientes</mat-label>
                    <input type="number" matInput [(ngModel)]="currentCreateCompany.numberUsersAprroveBusinessPartner"
                      name="numberUsersAprroveBusinessPartner" />
                  </mat-form-field>
                  <mat-form-field  class="w-full">
                    <mat-label>Modo para Calcular Peso</mat-label>
                    <mat-select [(ngModel)]="currentCreateCompany.loadCalculationMode" name="loadCalculationMode">
                      @for (calc of calcList; track calc) {
                      <mat-option [value]="calc">
                        {{ getCalculationLabel(calc) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field  class="w-full">
                    <mat-label>Modo de Creación de Socio</mat-label>
                    <mat-select [(ngModel)]="currentCreateCompany.businessPartnerCreationMode"
                      name="businessPartnerCreationMode">
                      @for (mode of modeList; track mode) {
                      <mat-option [value]="mode">
                        {{ getModeLabel(mode) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <div class="w-full">
                    <app-toggle-option
                      title="Unidad de medida paralela"
                      description="Habilitar unidad de medida paralela para la compañía"
                      icon="straighten"
                      iconColor="blue"
                      [(ngModel)]="currentCreateCompany.UMPActive"
                      name="UMPActive">
                    </app-toggle-option>
                  </div>
                  <div class="w-full">
                    <app-toggle-option
                      title="Integración ERP"
                      description="Habilitar integración con sistema ERP"
                      icon="sync"
                      iconColor="green"
                      [(ngModel)]="currentCreateCompany.ERPActive"
                      name="ERPActive">
                    </app-toggle-option>
                  </div>
                  <div class="w-full">
                    <app-toggle-option
                      title="Visualización de imágenes"
                      description="Permitir ver imágenes en la aplicación"
                      icon="image"
                      iconColor="purple"
                      [(ngModel)]="currentCreateCompany.isDisplayImages"
                      name="isDisplayImages">
                    </app-toggle-option>
                  </div>
                  <div class="grid gap-6 grid-cols-1 md:grid-cols-2 col-span-full">
                    <app-toggle-option title="Modificaciones de pedidos al ERP" description="Permite indicar si las modificaciones de pedidos deben enviarse automáticamente al ERP" icon="cached"
                      iconColor="green" [(ngModel)]="currentCreateCompany.sendOrderModificationsToERP" name="sendOrderModificationsToERP">
                    </app-toggle-option>
                    <app-toggle-option title="Sincronización de pedidos en distribución de inventario" description="Permite determinar si los pedidos ya sincronizados pueden incluirse en el proceso de distribución de inventario."
                     icon="inventory_2" iconColor="blue"  [(ngModel)]="currentCreateCompany.allowSyncOrdersInInventoryDistribution" name="allowSyncOrdersInInventoryDistribution">
                    </app-toggle-option>
                  </div>
                  <div class="grid gap-6 grid-cols-1 md:grid-cols-2 col-span-full">
                    <mat-form-field  class="w-full">
                      <mat-label>Consumo Máximo Cliente Eventual</mat-label>
                      <input type="text" matInput
                        [value]="formatNumber(currentCreateCompany.maximumConsumptionOfEventualCustomer)"
                        (input)="handleInputChange($event.target.value, 'create','maximumConsumptionOfEventualCustomer')"
                        name="maximumConsumptionOfEventualCustomer" />
                    </mat-form-field>
                    <mat-form-field  class="w-full">
                      <mat-label>Consumo Máximo Consumidor Final</mat-label>
                      <input type="text" matInput
                        [value]="formatNumber(currentCreateCompany.maximumConsumptionOfFinalConsumer)"
                        (input)="handleInputChange($event.target.value, 'create','maximumConsumptionOfFinalConsumer')"
                        name="createMaximumConsumption" />
                    </mat-form-field>
                  </div>
                </div>
              </app-form-section>

              <app-form-section title="Reglas de impuestos" icon="percent" iconColor="red">
                <div class="grid gap-6 grid-cols-1 lg:grid-cols-2">
                  <div class="w-full">
                    <app-toggle-option
                      title="Impuesto incluido en precios"
                      description="¿Los precios de los materiales incluyen impuesto?"
                      icon="attach_money"
                      iconColor="green"
                      [(ngModel)]="currentCreateCompany.isTaxIncluded"
                      name="isTaxIncluded">
                    </app-toggle-option>
                  </div>
                  <div class="w-full">
                    <app-toggle-option
                      title="Impuesto en exhibición"
                      description="¿El impuesto aplica a exhibición?"
                      icon="visibility"
                      iconColor="purple"
                      [(ngModel)]="currentCreateCompany.isDisplayItemTax"
                      name="isDisplayItemTax">
                    </app-toggle-option>
                  </div>
                </div>
              </app-form-section>              
              </form>
            </div>
          </mat-tab>
          <mat-tab label="Aplicaciones">
            <div class="table-container">
              <table mat-table [dataSource]="currentCreateCompany.applications">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Nombre</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.application.name }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                    <mat-slide-toggle [checked]="element.statusId === 1" (change)="
                        onStatusChangeApplications($event.checked, element)
                      " color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button color="primary" mat-button (click)="openApplicationsModal()"
                      matTooltip="Agregar Aplicación">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                      <button mat-icon-button (click)="openDeleteApplications(element)">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                      <button mat-icon-button (click)="openApplicationsModal(element)">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsApplications"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsApplications"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Contactos" [disabled]="!(contactTabPermissions.VIEW | hasPermission)">
            <div class="table-container">
              <table mat-table [dataSource]="currentCreateCompany.contacts">
                <ng-container matColumnDef="fullName">
                  <th mat-header-cell *matHeaderCellDef>Nombre Completo</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fullName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="emails">
                  <th mat-header-cell *matHeaderCellDef>Correo</th>
                  <!-- <td mat-cell *matCellDef="let element">
                    {{ element.emails?.email }}
                  </td> -->
                  <td mat-cell *matCellDef="let element">
                    <mat-icon color="primary" matBadge="{{element?.emails?.length || 0}}" matBadgeColor="accent"
                      matBadgeSize="small" aria-hidden="false">
                      email
                    </mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="phones">
                  <th mat-header-cell *matHeaderCellDef>Teléfono</th>
                  <!-- <td mat-cell *matCellDef="let element">
                    {{ element.phones }}
                  </td> -->
                  <td mat-cell *matCellDef="let element">
                    <mat-icon color="primary" matBadge="{{element?.phones?.length || 0}}" matBadgeColor="accent"
                      matBadgeSize="small" aria-hidden="false">
                      phone
                    </mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                    <mat-slide-toggle [checked]="element.statusId === 1"
                      (change)="onStatusChangeContact($event.checked, element)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="contactTabPermissions.CREATE" color="primary" mat-button (click)="openContactModal()" matTooltip="Agregar Contacto">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                      <button *canPermissionsOnly="contactTabPermissions.UPDATE" mat-icon-button (click)="openContactModal(element)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="contactTabPermissions.DELETE" mat-icon-button (click)="openDeleteContact(element)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsContact"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsContact"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Direcciones" [disabled]="!(addressTabPermissions.VIEW | hasPermission)">
            <div class="table-container">
              <table mat-table [dataSource]="currentCreateCompany.addresses">
                <!-- Define columns here -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Nombre</th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef>Dirección</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.address }}
                  </td>
                </ng-container>
                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                    <mat-slide-toggle [checked]="element.statusId === 1"
                      (change)="onStatusChangeAddress($event.checked, element)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="addressTabPermissions.CREATE" color="primary" mat-button (click)="openAddressModal()" matTooltip="Agregar Dirección">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                      <button *canPermissionsOnly="addressTabPermissions.UPDATE" mat-icon-button (click)="openAddressModal(element)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="addressTabPermissions.DELETE" mat-icon-button (click)="openDeleteAddress(element)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsAddress"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsAddress"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Datos de Contacto" [disabled]="!(contactDataTabPermissions.VIEW | hasPermission)">
            <div class="table-container">
              <table mat-table [dataSource]="currentCreateCompany.phones">
                <!-- Define columns here -->
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>Tipo</th>
                  <td mat-cell *matCellDef="let phone"> {{phone.type?.type}}</td>
                </ng-container>
                <ng-container matColumnDef="prefix">
                  <th mat-header-cell *matHeaderCellDef> Número Teléfonico </th>
                  <td mat-cell *matCellDef="let phone"> {{phone.prefix}} {{phone.phone}} </td>
                </ng-container>
                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let phone" class="px-6 text-left">
                    <mat-slide-toggle [checked]="phone.statusId === 1"
                      (change)="onStatusChangePhone($event.checked, phone)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="contactDataTabPermissions.CREATE" color="primary" mat-button (click)="openPhoneModal()" matTooltip="Agregar Teléfono">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let phone">
                    <div class="button-container">
                      <button *canPermissionsOnly="contactDataTabPermissions.UPDATE" mat-icon-button (click)="openPhoneModal(phone)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="contactDataTabPermissions.DELETE" mat-icon-button (click)="openDeletePhone(phone)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsPhone"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsPhone"></tr>
              </table>
            </div>
            <!-- Email -->
            <div class="table-container">
              <table mat-table [dataSource]="currentCreateCompany.emails">
                <!-- Define columns here -->
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef>Correo Electrónico </th>
                  <td mat-cell *matCellDef="let email">{{ email.email }}</td>
                </ng-container>
                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let email" class="px-6 text-left">
                    <mat-slide-toggle [checked]="email.statusId === 1"
                      (change)="onStatusChangeEmail($event.checked, email)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="contactDataTabPermissions.CREATE" color="primary" mat-button (click)="openEmailModal()" matTooltip="Agregar Email">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let email">
                    <div class="button-container">
                      <button *canPermissionsOnly="contactDataTabPermissions.UPDATE" mat-icon-button (click)="openEmailModal(email)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="contactDataTabPermissions.DELETE" mat-icon-button (click)="openDeleteEmail(email)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsEmail"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsEmail"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Cloud Sales Mobile">
            <mat-tab-group>
              <mat-tab label="Rutero">
                <form #createForm="ngForm">
                  <div class="p-4 rounded-lg mb-10">
                    <h3 class="text-lg font-semibold mb-4 text-gray-800">Ruteo</h3>
                    <div class="grid gap-6 grid-cols-1 lg:grid-cols-2">
                      <div class="w-full">
                        <app-toggle-option
                          title="Validar stock en ruta"
                          description="Habilitar validación de stock durante el ruteo"
                          icon="inventory_2"
                          iconColor="orange"
                          [(ngModel)]="currentCreateCompany.validateStockInRouting"
                          name="validateStockInRouting">
                        </app-toggle-option>
                      </div>
                      <div class="w-full">
                        <app-toggle-option
                          title="Agrupar stock por fecha"
                          description="Agrupar inventario por fecha en ruteo"
                          icon="date_range"
                          iconColor="blue"
                          [(ngModel)]="currentCreateCompany.groupStockByDateInRouting"
                          name="groupStockByDateInRouting">
                        </app-toggle-option>
                      </div>
                    </div>
                    @if(currentCreateCompany.groupStockByDateInRouting){
                    <div class="grid gap-6 grid-cols-1 md:grid-cols-2 mt-4">
                      <mat-form-field  class="w-full">
                        <mat-label>Total Meses</mat-label>
                        <input type="number" matInput [(ngModel)]="currentCreateCompany.totalMonthsToGroupStockInRouting"
                          name="totalMonthsToGroupStockInRouting" />
                      </mat-form-field>
                      <mat-form-field  class="w-full">
                        <mat-label>Segmentación de Meses</mat-label>
                        <input type="number" matInput [(ngModel)]="currentCreateCompany.monthsToGroupStockInRouting"
                          name="monthsToGroupStockInRouting" />
                      </mat-form-field>
                    </div>
                    }
                  </div>

                  <div class="bg-white p-4 rounded-lg border border-gray-200 mb-8">
                    <h3 class="text-lg font-semibold mb-4 text-gray-800">Horario de toma de pedidos en preventa</h3>
                    <p class="mb-5 text-xs text-gray-600 md:text-sm">
                      Restringe la toma de pedidos en preventa desde la app móvil a una ventana horaria.
                    </p>

                    <mat-form-field class="w-full">
                      <mat-label>Modo de validación del horario de preventa</mat-label>
                      <mat-select [(ngModel)]="currentCreateCompany.preSaleOrderScheduleEnabled"
                        name="preSaleOrderScheduleEnabled">
                        @for (opt of preSaleOrderScheduleModeOptions; track opt.value) {
                        <mat-option [value]="opt.value">
                          {{ opt.label }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <div class="mt-4 border-t border-gray-200 pt-3">
                      <div class="mt-3 flex flex-col gap-4 sm:flex-row">
                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Hora de inicio</mat-label>
                          <mat-icon matSuffix>schedule</mat-icon>
                          <input matInput [(ngModel)]="currentCreateCompany.preSaleOrderStartTime"
                            name="preSaleOrderStartTime" [ngxTimepicker]="preSaleStartPicker" [format]="12"
                            [disabled]="!preSaleScheduleEnabledCreate"
                            [errorStateMatcher]="preSaleStartErrorMatcherCreate" />
                          <ngx-material-timepicker #preSaleStartPicker [format]="12"
                            (timeSet)="onPreSaleTimeSet('create', 'start', $event)"></ngx-material-timepicker>
                          <mat-error *ngIf="preSaleScheduleEnabledCreate && !currentCreateCompany.preSaleOrderStartTime">
                            La hora de inicio es obligatoria
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Hora de fin</mat-label>
                          <mat-icon matSuffix>schedule</mat-icon>
                          <input matInput [(ngModel)]="currentCreateCompany.preSaleOrderEndTime"
                            name="preSaleOrderEndTime" [ngxTimepicker]="preSaleEndPicker" [format]="12"
                            [disabled]="!preSaleScheduleEnabledCreate"
                            [errorStateMatcher]="preSaleEndErrorMatcherCreate" />
                          <ngx-material-timepicker #preSaleEndPicker [format]="12"
                            (timeSet)="onPreSaleTimeSet('create', 'end', $event)"></ngx-material-timepicker>
                          <mat-error *ngIf="preSaleScheduleEnabledCreate && !currentCreateCompany.preSaleOrderEndTime">
                            La hora de fin es obligatoria
                          </mat-error>
                          <mat-error *ngIf="preSaleRangeErrorCreate">
                            La hora de inicio debe ser anterior a la hora de fin
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="bg-gray-50 p-4 rounded-lg mb-8">
                    <h3 class="text-lg font-semibold mb-4 text-gray-800">Configuración GPS</h3>
                    <div class="w-full">
                      <app-toggle-option
                        title="Validación GPS"
                        description="¿Se valida el GPS en las rutas?"
                        icon="location_on"
                        iconColor="red"
                        [(ngModel)]="currentCreateCompany.useGPSInCSMmobile"
                        name="useGPSInCSMmobile">
                      </app-toggle-option>
                    </div>
                    @if (currentCreateCompany.useGPSInCSMmobile) {
                    <div class="mt-4 border-t border-gray-200 pt-3">
                      <div class="mt-3 flex flex-col gap-4 sm:flex-row">
                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Modo de validación GPS</mat-label>
                          <mat-select [(ngModel)]="currentCreateCompany.useGpsMode" name="useGpsMode">
                            @for (mode of useGpsList; track mode.value) {
                            <mat-option [value]="mode.value">
                              {{ mode.key | transloco }}
                            </mat-option>
                            }
                          </mat-select>
                          <mat-hint>Se aplica a las rutas configuradas como "De acuerdo a compañía"</mat-hint>
                        </mat-form-field>
                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Distancia a validar entre el vendedor y cliente</mat-label>
                          <input type="number" matInput [(ngModel)]="currentCreateCompany.distanceBetween.sellerToCustomer"
                            name="sellerToCustomer" />
                          <mat-suffix>km</mat-suffix>
                        </mat-form-field>
                      </div>
                    </div>
                    }

                    <div class="grid gap-6 grid-cols-1 lg:grid-cols-2 mt-6">
                      <div class="w-full">
                        <app-toggle-option
                          title="Purgado de viaje"
                          description="Habilitar purgado de viaje (Total/Parcial) y liberación de pedido"
                          icon="refresh"
                          iconColor="purple"
                          [(ngModel)]="currentCreateCompany.isAvailableTripPurge"
                          name="isAvailableTripPurge">
                        </app-toggle-option>
                      </div>
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label>Modo de determinación de condiciones comerciales</mat-label>
                          <mat-select [(ngModel)]="currentCreateCompany.commercialConditionMode" name="commercialConditionMode">
                            @for (mode of commercialConditionModeList; track mode.value) {
                            <mat-option [value]="mode.value">
                              {{ mode.label }}
                            </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="grid gap-6 grid-cols-1 lg:grid-cols-2 mt-6">
                    <mat-form-field  class="w-full">
                      <mat-label>Clase de documento para Merma (Por defecto)</mat-label>
                      <mat-select [(ngModel)]="currentCreateCompany.documentClassIdToWaste" name="documentClassIdToWaste">
                        <!-- <mat-option>
                          <ngx-mat-select-search [ngModelOptions]="{ standalone: true }"
                            placeholderLabel="Buscar documento..." noEntriesFoundLabel="No se encontraron resultados">
                          </ngx-mat-select-search>
                        </mat-option> -->
                        @for (item of filteredDocumentClassList; track item) {
                        <mat-option [value]="item._id">
                          <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field  class="w-full">
                      <mat-label> Clase de documento para devoluciones(Por defecto)</mat-label>
                      <mat-select [(ngModel)]="currentCreateCompany.documentClassIdToReturn" name="documentClassIdToReturn">
                        <!-- <mat-option>
                          <ngx-mat-select-search [ngModelOptions]="{ standalone: true }"
                            placeholderLabel="Buscar documento..." noEntriesFoundLabel="No se encontraron resultados">
                          </ngx-mat-select-search>
                        </mat-option> -->
                        @for (item of filteredDocumentClassListReturn; track item) {
                        <mat-option [value]="item._id">
                          <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="md:flex items-baseline text-center mt-6 col-span-1">
                    <mat-form-field  class="w-full">
                      <mat-label>Tipos de documento que hacen envío automático a ERP al cerrar viaje</mat-label>
                      <mat-select [(ngModel)]="currentCreateCompany.docTypesToSendToERPatCloseTrip"
                        name="docTypesToSendToERPatCloseTrip">
                        <mat-option>
                          <ngx-mat-select-search [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                            noEntriesFoundLabel="No se encontraron resultados">
                          </ngx-mat-select-search>
                        </mat-option>
                        @for (item of listFilterdocumentTypeList; track item) {
                        <mat-option [value]="item">
                          <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <button mat-icon-button color="primary" class="ml-2 mt-1" (click)="addRelatedDocumentCreate()"
                      [disabled]="
                      !currentCreateCompany.docTypesToSendToERPatCloseTrip ||
                      currentCreateCompany.docTypesToSendToERPatCloseTrip.length === 0
                    " matTooltip="Agregar tipo de documento">
                      <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                  </div>
                  <div class="col-span-4" style="max-height: 300px; overflow-y: auto">
                    <table mat-table [dataSource]="dataSourceDocument" class="min-w-500 overflow-y-visible mat-elevation-z">
                      <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef>Código</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element?.code }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element?.name }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element; let i = index">
                          <div class="button-container">
                            <button *canPermissionsOnly="PERMISSIONS.UPDATE" (click)="deleteItem(i)" mat-icon-button>
                              <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                            </button>
                          </div>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumnsDocument" class="sticky top-0 z-10 bg-white">
                      </tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsDocument"></tr>
                    </table>
                  </div>
                </form>
              </mat-tab>   
              <mat-tab label="Visualización de materiales">
                <form #createForm="ngForm">
                  <div class="grid grid-cols-2 gap-4 col-span-2 mt-2">
                    <div class="col-span-2">
                      <app-toggle-option
                        title="Configuración de materiales"
                        description="Habilitar Configuración de materiales"
                        icon="view_quilt"
                        iconColor="blue"
                        [(ngModel)]="currentCreateCompany.useMaterialAppDisplayConfig"
                        name="useMaterialAppDisplayConfig">
                      </app-toggle-option>
                    </div>
                    @if(currentCreateCompany.useMaterialAppDisplayConfig){
                      <div class="col-span-2">
                        <app-form-section
                          title="Configuración de visualización de materiales"
                          icon="view_quilt"
                          iconColor="blue">

                          <div class="grid gap-6 grid-cols-1 lg:grid-cols-2">
                            <!-- Productos relacionados -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Productos relacionados"
                                description="Mostrar productos relacionados en la aplicación de materiales."
                                icon="widgets"
                                iconColor="indigo"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showRelatedProducts"
                                name="showRelatedProducts">
                              </app-toggle-option>
                            </div>

                            <!-- Código de barras -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Código de barras"
                                description="Mostrar el código de barras de los materiales."
                                icon="qr_code"
                                iconColor="cyan"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showBarcode"
                                name="showBarcode">
                              </app-toggle-option>
                            </div>                  

                            <!-- Cantidad deseada de venta -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Cantidad deseada de venta"
                                description="Mostrar la cantidad deseada de venta."
                                icon="shopping_cart"
                                iconColor="red"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showDesiredSaleQty"
                                name="showDesiredSaleQty">
                              </app-toggle-option>
                            </div>

                            <!-- Precios por corto vencimiento -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Precio por corto vencimiento"
                                description="Mostrar si el producto tiene precios por corto vencimiento."
                                icon="schedule"
                                iconColor="orange"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showShortExpiryPrice"
                                name="showShortExpiryPrice">
                              </app-toggle-option>
                            </div>                  

                            <!-- Cantidad mínima de venta -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Cantidad mínima de venta"
                                description="Mostrar la cantidad mínima de venta permitida."
                                icon="format_list_numbered"
                                iconColor="pink"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showMinimumSale"
                                name="showMinimumSale">
                              </app-toggle-option>
                            </div>

                            <!-- Stock disponible -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Stock disponible"
                                description="Mostrar el stock disponible del material."
                                icon="inventory_2"
                                iconColor="amber"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showStockAvailable"
                                name="showStockAvailable">
                              </app-toggle-option>
                            </div>

                            <!-- Equivalencias de unidad -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Equivalencias de unidad"
                                description="Mostrar equivalencia entre unidad de medida paralela y base o entre unidad de venta y base."
                                icon="swap_horiz"
                                iconColor="teal"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showUnitEquivalence"
                                name="showUnitEquivalence">
                              </app-toggle-option>
                            </div>

                            <!-- Número de destinatarios -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Número de destinatarios"
                                description="Mostrar número de destinatarios (multiplica la cantidad por el número de destinatarios)."
                                icon="groups"
                                iconColor="purple"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showRecipientsCount"
                                name="showRecipientsCount">
                              </app-toggle-option>
                            </div>

                            <!-- Precio por escala -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Precio por escala"
                                description="Mostrar indicador de precios por escala (el precio puede subir o bajar según cantidad)."
                                icon="trending_up"
                                iconColor="green"
                                [(ngModel)]="currentCreateCompany.materialAppDisplayConfig.showScalePrice"
                                name="showScalePrice">
                              </app-toggle-option>
                            </div>
                          </div>
                        </app-form-section>
                      </div>
                    }
                  </div>
                </form>
              </mat-tab>
            </mat-tab-group>         

          </mat-tab>
          <mat-tab label="Finanzas">
            <form #financeForm="ngForm">
              <h3 class="col-span-2 mt-4">Configuración de Referencias para Partidas Abiertas</h3>
              <div class="grid grid-cols-1 gap-4 col-span-2 mt-4">
                <div class="flex items-center gap-2">
                  <mat-form-field  class="flex-1">
                    <mat-label>Nr. Nota de crédito para pagos </mat-label>
                    <mat-select [(ngModel)]="currentCreateCompany.creditNoteField" name="creditNoteField">
                      @for (referenceType of getAvailableReferenceTypes(['creditNoteField']); track referenceType) {
                      <mat-option [value]="referenceType">
                        {{ referenceTypeLabels[referenceType] }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="warn" (click)="clearCreditNoteField()"
                    [disabled]="!currentCreateCompany.creditNoteField" matTooltip="Limpiar selección">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>

                <div class="flex items-center gap-2">
                  <mat-form-field  class="flex-1">
                    <mat-label>Nr. Anticipo para pagos </mat-label>
                    <mat-select [(ngModel)]="currentCreateCompany.advancePaymentField" name="advancePaymentField">
                      @for (referenceType of getAvailableReferenceTypes(['advancePaymentField']); track referenceType) {
                      <mat-option [value]="referenceType">
                        {{ referenceTypeLabels[referenceType] }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="warn" (click)="clearAdvancePaymentField()"
                    [disabled]="!currentCreateCompany.advancePaymentField" matTooltip="Limpiar selección">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>

                <div class="flex items-center gap-2">
                  <mat-form-field  class="flex-1">
                    <mat-label>Siempre se muestra en </mat-label>
                    <mat-select [(ngModel)]="currentCreateCompany.accountStatementReferenceField"
                      name="accountStatementReferenceField">
                      @for (referenceType of getAvailableReferenceTypes(['accountStatementReferenceField']); track
                      referenceType) {
                      <mat-option [value]="referenceType">
                        {{ referenceTypeLabels[referenceType] }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="warn" (click)="clearAccountStatementReferenceField()"
                    [disabled]="!currentCreateCompany.accountStatementReferenceField" matTooltip="Limpiar selección">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Carga de datos">
            <div class="py-6">
              <form #loadingAssistantForm="ngForm" class="space-y-8 flex flex-col">
                <app-form-section title="Configuración de importación desde Excel" icon="upload_file" iconColor="indigo">
                  <div class="space-y-6">
                    <app-toggle-option
                      [(ngModel)]="currentCreateCompany.loadingAssistantEnableZeroPadding"
                      name="loadingAssistantEnableZeroPadding"
                      title="Habilitar validación de longitud de códigos"
                      description="Al importar datos desde Excel, se validará que los códigos tengan la cantidad exacta de dígitos configurada"
                      icon="rule"
                      iconColor="indigo"
                      [showExpandedContent]="false">
                    </app-toggle-option>

                    <div *ngIf="currentCreateCompany.loadingAssistantEnableZeroPadding" class="grid gap-6 grid-cols-1 md:grid-cols-3 mt-6">
                      <mat-form-field  class="w-full">
                        <mat-label>Dígitos totales para materiales</mat-label>
                        <input matInput
                          type="number"
                          [(ngModel)]="currentCreateCompany.loadingAssistantMaterialZeroPaddingSize"
                          name="loadingAssistantMaterialZeroPaddingSize"
                          min="0"
                          max="20" />
                        <mat-hint>Longitud total del código de materiales en archivo Excel</mat-hint>
                      </mat-form-field>

                      <mat-form-field  class="w-full">
                        <mat-label>Dígitos totales para clientes</mat-label>
                        <input matInput
                          type="number"
                          [(ngModel)]="currentCreateCompany.loadingAssistantCustomerPaddingSize"
                          name="loadingAssistantCustomerPaddingSize"
                          min="0"
                          max="20" />
                        <mat-hint>Longitud total del código de clientes en archivo Excel</mat-hint>
                      </mat-form-field>

                      <mat-form-field  class="w-full">
                        <mat-label>Dígitos totales para sub-rutas</mat-label>
                        <input matInput
                          type="number"
                          [(ngModel)]="currentCreateCompany.loadingAssistantSubRoutePaddingSize"
                          name="loadingAssistantSubRoutePaddingSize"
                          min="0"
                          max="20" />
                        <mat-hint>Longitud total del código de sub-rutas en archivo Excel</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </app-form-section>
              </form>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-dialog-content>
      <mat-dialog-actions class="flex justify-between items-center p-6 border-t mt-6">
        <button mat-button mat-dialog-close class="px-6 py-2">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createCompany()"
          [disabled]="!createForm.valid || companySaved" class="px-6 py-2">
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-xl font-bold mb-4 px-6 py-4 border-b">
        Editar Registro - {{ this.currentUpdateCompany.name }}
      </h2>
      <mat-dialog-content class="overflow-y-auto max-h-full">
        <mat-tab-group class="mb-4">
          <mat-tab label="Datos Generales">
            <div class="py-6">
              <form #editForm="ngForm" class="space-y-8 flex flex-col">
              <app-form-section title="Información Básica" icon="business" iconColor="blue">
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                  <mat-form-field  class="w-full">
                    <mat-label>Nombre Legal</mat-label>
                    <input matInput [(ngModel)]="currentUpdateCompany.name" name="name" required />
                    <mat-error *ngIf="!currentUpdateCompany.name">Este campo es requerido</mat-error>
                  </mat-form-field>
                  <mat-form-field  class="w-full">
                    <mat-label>Nombre Comercial</mat-label>
                    <input matInput [(ngModel)]="currentUpdateCompany.tradeName" name="tradeName" />
                  </mat-form-field>
                  <mat-form-field  class="w-full">
                    <mat-label>RTN</mat-label>
                    <input matInput [(ngModel)]="currentUpdateCompany.NIT" name="NIT" />
                  </mat-form-field>
                </div>
              </app-form-section>
              <app-form-section title="Póliticas comerciales" icon="currency_exchange" iconColor="green">
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
                  <div class="w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Lista de Precios</label>
                    <ng-select [(ngModel)]="currentUpdateCompany.priceList" [items]="priceList" bindLabel="name"
                      bindValue="_id" [searchable]="true" placeholder="Seleccione una lista de precios" name="priceListId"
                      (ngModelChange)="onPriceSelectionChange($event)" [compareWith]="compareById" [appendTo]="'body'">
                      <!-- Personalizar la visualización de los ítems en la lista desplegable -->
                      <ng-template ng-label-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        <!-- Mostramos el código y el nombre -->
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        <!-- Mostramos el código y el nombre -->
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="col-span-1">
                    <label>Lista de Descuentos</label>
                    <ng-select [(ngModel)]="currentUpdateCompany.discountList" [items]="discountList" bindLabel="name"
                      bindValue="_id" [searchable]="true" placeholder="Seleccione un precio de descuento"
                      name="discountListId" (ngModelChange)="onDiscountPriceSelectionChange($event)"
                      [compareWith]="compareById" [appendTo]="'body'">
                      <!-- Personalizar la visualización de los ítems en la lista desplegable -->
                      <ng-template ng-label-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        <!-- Mostramos el código y el nombre -->
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <span><b>{{ item.code }}</b> - {{ item.name }}</span>
                        <!-- Mostramos el código y el nombre -->
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Moneda</label>
                    <ng-select [(ngModel)]="currentUpdateCompany.currencyBase" [items]="currencyList" bindLabel="name"
                      bindValue="_id" [searchable]="true" placeholder="Seleccione una tasa de cambio"
                      name="currencyBaseId" (ngModelChange)="onCurrencySelectionChange($event)"
                      [compareWith]="compareById" [appendTo]="'body'" class="w-full">
                    </ng-select>
                  </div>
                  <div class="grid md:grid-cols-2 gap-4">
                    <mat-form-field  class="w-full">
                      <mat-label>Máx. carácteres en series de numeración de documentos</mat-label>
                      <input type="number" matInput [(ngModel)]="currentUpdateCompany.emissionPointSeriesLength"
                        name="emissionPointSeriesLength" min="0" placeholder="20" />
                      <mat-hint>0 = ilimitado, por defecto 20 caracteres</mat-hint>
                    </mat-form-field>
                    <mat-form-field  class="w-full" matTooltip="Define la cantidad máxima de dígitos que puede tener la numeración de los documentos" matTooltipPosition="above">
                      <mat-label># caracteres en la numeración de rangos</mat-label>
                      <input type="number" matInput [(ngModel)]="currentUpdateCompany.documentNumberLength"
                        name="documentNumberLength" min="1" max="12" placeholder="8" #documentNumberLength="ngModel"/>
                      <mat-error *ngIf="documentNumberLength.errors?.['min'] || documentNumberLength.errors?.['max']">
                        Solo se aceptan valores entre 1 y 12
                      </mat-error>
                  </mat-form-field>
                  </div>
                  <div class="w-full">
                    <app-toggle-option
                      title="Bonificación en totales"
                      description="¿Se incluye valor de Bonificación en totales?"
                      icon="money"
                      iconColor="purple"
                      [(ngModel)]="currentUpdateCompany.includeBonusInTotals"
                      name="includeBonusInTotals">
                    </app-toggle-option>
                  </div>
                  <div class="w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Precio de la bonificación</label>
                    <ng-select
                      [(ngModel)]="currentUpdateCompany.bonusPriceBehavior"
                      [items]="bonusPriceBehaviorOptions"
                      bindLabel="label"
                      bindValue="value"
                      placeholder="Seleccione un comportamiento"
                      name="bonusPriceBehavior"
                      class="w-full"
                      [disabled]="!currentUpdateCompany.includeBonusInTotals">
                    </ng-select>
                  </div>                  
                </div>
               
              </app-form-section>
             
              <app-form-section title="Configuración de decimales" icon="calculate" iconColor="green">
                <div class="grid gap-6 grid-cols-1 md:grid-cols-3">
              
                  <!-- Precios -->
                  <mat-form-field class="w-full" matTooltip="# de decimales a mostrar para precios" matTooltipPosition="above">
                    <mat-label># de decimales a mostrar para precios</mat-label>
                    <input type="number" matInput [(ngModel)]="currentUpdateCompany.numberOfDecimals" name="numberOfDecimals" min="0"
                      step="1" #numberOfDecimals="ngModel" />
                    <mat-error *ngIf="numberOfDecimals?.model < 0">
                      No se aceptan números negativos
                    </mat-error>
                  </mat-form-field>
              
                  <mat-form-field class="w-full" matTooltip="# de decimales para calcular precios" matTooltipPosition="above">
                    <mat-label># de decimales para calcular precios</mat-label>
                    <input type="number" matInput [(ngModel)]="currentUpdateCompany.priceDecimalsWork" name="priceDecimalsWork"
                      min="0" step="1" #priceDecimalsWork="ngModel" />
                    <mat-error *ngIf="priceDecimalsWork?.model < 0">
                      No se aceptan números negativos
                    </mat-error>
                  </mat-form-field>
              
                  <!-- Stock -->
                  <mat-form-field class="w-full" matTooltip="# de decimales a mostrar para stock" matTooltipPosition="above">
                    <mat-label># de decimales a mostrar para stock</mat-label>
                    <input type="number" matInput [(ngModel)]="currentUpdateCompany.stockDecimalsDisplay" name="stockDecimalsDisplay"
                      min="0" step="1" #stockDecimalsDisplay="ngModel" />
                    <mat-error *ngIf="stockDecimalsDisplay?.model < 0">
                      No se aceptan números negativos
                    </mat-error>
                  </mat-form-field>
              
                  <mat-form-field class="w-full" matTooltip="# de decimales para calcular stock" matTooltipPosition="above">
                    <mat-label># de decimales para calcular stock</mat-label>
                    <input type="number" matInput [(ngModel)]="currentUpdateCompany.stockDecimalsWork" name="stockDecimalsWork"
                      min="0" step="1" #stockDecimalsWork="ngModel" />
                    <mat-error *ngIf="stockDecimalsWork?.model < 0">
                      No se aceptan números negativos
                    </mat-error>
                  </mat-form-field>
              
                  <!-- Pagos -->
                  <mat-form-field class="w-full" matTooltip="# de decimales a mostrar para pagos" matTooltipPosition="above">
                    <mat-label># de decimales a mostrar para pagos</mat-label>
                    <input type="number" matInput [(ngModel)]="currentUpdateCompany.payDecimalView" name="payDecimalView" min="0"
                      step="1" #payDecimalView="ngModel" />
                    <mat-error *ngIf="payDecimalView?.model < 0">
                      No se aceptan números negativos
                    </mat-error>
                  </mat-form-field>
              
                  <mat-form-field class="w-full" matTooltip="# de decimales para calcular pagos" matTooltipPosition="above">
                    <mat-label># de decimales para calcular pagos</mat-label>
                    <input type="number" matInput [(ngModel)]="currentUpdateCompany.payDecimalWork" name="payDecimalWork" min="0"
                      step="1" #payDecimalWork="ngModel" />
                    <mat-error *ngIf="payDecimalWork?.model < 0">
                      No se aceptan números negativos
                    </mat-error>
                  </mat-form-field>
              
                </div>
              </app-form-section>

              <app-form-section title="Configuración de Negocio" icon="settings" iconColor="purple">
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                  <mat-form-field  class="w-full">
                    <mat-label># Aprobadores de nuevos clientes</mat-label>
                    <input type="number" matInput [(ngModel)]="currentUpdateCompany.numberUsersAprroveBusinessPartner"
                      name="numberUsersAprroveBusinessPartner" />
                  </mat-form-field>
                  <mat-form-field  class="w-full">
                    <mat-label>Modo para Calcular Peso</mat-label>
                    <mat-select [(ngModel)]="currentUpdateCompany.loadCalculationMode" name="loadCalculationMode">
                      @for (calc of calcList; track calc) {
                      <mat-option [value]="calc">
                        {{ getCalculationLabel(calc) }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                <mat-form-field class="col-span-1">
                  <mat-label>Modo de Creación de Socio</mat-label>
                  <mat-select [(ngModel)]="currentUpdateCompany.businessPartnerCreationMode" name="businessPartnerCreationMode">
                    <mat-option *ngFor="let mode of modeList" [value]="mode" [disabled]="isModeDisabled(mode, currentUpdateCompany)">
                      {{ getModeLabel(mode) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                  <app-toggle-option
                    title="Unidad de medida paralela"
                    description="Habilitar unidad de medida paralela para la compañía"
                    icon="straighten"
                    iconColor="blue"
                    [(ngModel)]="currentUpdateCompany.UMPActive"
                    name="UMPActive"
                    class="col-span-1">
                  </app-toggle-option>

                  <app-toggle-option
                    title="Integración ERP"
                    description="Habilitar integración con sistema ERP"
                    icon="sync"
                    iconColor="green"
                    [(ngModel)]="currentUpdateCompany.ERPActive"
                    name="ERPActive"
                    class="col-span-1">
                  </app-toggle-option>

                  <app-toggle-option
                    title="Visualización de imágenes"
                    description="Permitir ver imágenes en la aplicación"
                    icon="image"
                    iconColor="purple"
                    [(ngModel)]="currentUpdateCompany.isDisplayImages"
                    name="isDisplayImages"
                    class="col-span-1">
                  </app-toggle-option>
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2 col-span-full">
                  <app-toggle-option title="Modificaciones de pedidos al ERP"
                    description="Permite indicar si los pedidos modificados deben enviarse automáticamente al ERP" icon="cached"
                    iconColor="green" [(ngModel)]="currentUpdateCompany.sendOrderModificationsToERP" name="sendOrderModificationsToERP">
                  </app-toggle-option>
                  <app-toggle-option title="Sincronización de pedidos en distribución de inventario"
                    description="Permite determinar si los pedidos ya sincronizados pueden incluirse en el proceso de distribución de inventario."
                    icon="inventory_2" iconColor="blue" [(ngModel)]="currentUpdateCompany.allowSyncOrdersInInventoryDistribution"
                    name="allowSyncOrdersInInventoryDistribution">
                  </app-toggle-option>
                </div>
                  <div class="grid grid-cols-2 gap-4 col-span-full">
                    <mat-form-field  class="col-span-1">
                      <mat-label>Consumo Máximo Cliente Eventual</mat-label>
                      <input type="text" matInput
                        [value]="formatNumber(currentUpdateCompany.maximumConsumptionOfEventualCustomer)"
                        (input)="handleInputChange($event.target.value, 'update','maximumConsumptionOfEventualCustomer')"
                        name="maximumConsumptionOfEventualCustomer">
                    </mat-form-field>
                    <mat-form-field  class="col-span-1">
                      <mat-label>Consumo Máximo Consumidor Final</mat-label>
                      <input type="text" matInput
                        [value]="formatNumber(currentUpdateCompany.maximumConsumptionOfFinalConsumer)"
                        (input)="handleInputChange($event.target.value, 'update','maximumConsumptionOfFinalConsumer')"
                        name="updateMaximumConsumption">
                    </mat-form-field>
                  </div>

                </div>
              </app-form-section>

              <app-form-section title="Reglas de impuestos" icon="percent" iconColor="red">
                <div class="grid grid-cols-2 gap-4">
                  <div class="col-span-1">
                    <app-toggle-option
                      title="Impuesto incluido en precios"
                      description="¿Los precios de los materiales incluyen impuesto?"
                      icon="attach_money"
                      iconColor="green"
                      [(ngModel)]="currentUpdateCompany.isTaxIncluded"
                      name="isTaxIncluded">
                    </app-toggle-option>
                  </div>
                  <div class="col-span-1">
                    <app-toggle-option
                      title="Impuesto en exhibición"
                      description="¿El impuesto aplica a exhibición?"
                      icon="visibility"
                      iconColor="purple"
                      [(ngModel)]="currentUpdateCompany.isDisplayItemTax"
                      name="isDisplayItemTax">
                    </app-toggle-option>
                  </div>
                </div>
              </app-form-section>              
              </form>
            </div>
          </mat-tab>

          <mat-tab label="Contactos" [disabled]="!(contactTabPermissions.VIEW | hasPermission)">
            <div class="table-container">
              <table mat-table [dataSource]="currentUpdateCompany.contacts">
                <ng-container matColumnDef="fullName">
                  <th mat-header-cell *matHeaderCellDef>Nombre Completo</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fullName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef>Apellido</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.lastName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="emails">
                  <th mat-header-cell *matHeaderCellDef>Correo</th>
                  <!-- <td mat-cell *matCellDef="let element">
                    {{ element.emails?.email }}
                  </td> -->
                  <td mat-cell *matCellDef="let element">
                    <mat-icon color="primary" matBadge="{{element?.emails?.length || 0}}" matBadgeColor="accent"
                      matBadgeSize="small" aria-hidden="false">
                      email
                    </mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="phones">
                  <th mat-header-cell *matHeaderCellDef>Teléfono</th>
                  <!-- <td mat-cell *matCellDef="let element">
                    {{ element.phones }}
                  </td> -->
                  <td mat-cell *matCellDef="let element">
                    <mat-icon color="primary" matBadge="{{element?.phones?.length || 0}}" matBadgeColor="accent"
                      matBadgeSize="small" aria-hidden="false">
                      phone
                    </mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                    <mat-slide-toggle [checked]="element.statusId === 1"
                      (change)="onStatusChangeContact($event.checked, element)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="contactTabPermissions.CREATE" color="primary" mat-button (click)="openContactModal()" matTooltip="Agregar Contacto">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                      <button *canPermissionsOnly="contactTabPermissions.UPDATE" mat-icon-button (click)="openContactModal(element)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="contactTabPermissions.DELETE" mat-icon-button (click)="openDeleteContact(element)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsContact"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsContact"></tr>
              </table>
            </div>
          </mat-tab>

          <mat-tab label="Direcciones" [disabled]="!(addressTabPermissions.VIEW | hasPermission)">
            <div class="table-container">
              <table mat-table [dataSource]="currentUpdateCompany.addresses">
                <!-- Define columns here -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Nombre</th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef>Dirección</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.address }}
                  </td>
                </ng-container>
                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                    <mat-slide-toggle [checked]="element.statusId === 1"
                      (change)="onStatusChangeAddress($event.checked, element)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="addressTabPermissions.CREATE" color="primary" mat-button (click)="openAddressModal()" matTooltip="Agregar Dirección">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                      <button *canPermissionsOnly="addressTabPermissions.UPDATE" mat-icon-button (click)="openAddressModal(element)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="addressTabPermissions.DELETE" mat-icon-button (click)="openDeleteAddress(element)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsAddress"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsAddress"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Datos de Contacto" [disabled]="!(contactDataTabPermissions.VIEW | hasPermission)">
            <div class="table-container">
              <table mat-table [dataSource]="currentUpdateCompany.phones">
                <!-- Define columns here -->
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef>Tipo</th>
                  <td mat-cell *matCellDef="let phone"> {{phone.type?.type}} </td>
                </ng-container>
                <ng-container matColumnDef="prefix">
                  <th mat-header-cell *matHeaderCellDef> Número Teléfonico </th>
                  <td mat-cell *matCellDef="let phone"> {{phone.prefix}} {{phone.phone}} </td>
                </ng-container>
                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let phone" class="px-6 text-left">
                    <mat-slide-toggle [checked]="phone.statusId === 1"
                      (change)="onStatusChangePhone($event.checked, phone)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="contactDataTabPermissions.CREATE" color="primary" mat-button (click)="openPhoneModal()" matTooltip="Agregar Teléfono">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let phone">
                    <div class="button-container">
                      <button *canPermissionsOnly="contactDataTabPermissions.UPDATE" mat-icon-button (click)="openPhoneModal(phone)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="contactDataTabPermissions.DELETE" mat-icon-button (click)="openDeletePhone(phone)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsPhone"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsPhone"></tr>
              </table>
            </div>
            <!-- Email -->
            <!-- <h3>Correos</h3> -->
            <!-- <div class="flex justify-end mb-2">
              <button *canPermissionsOnly="contactDataTabPermissions.CREATE"
              mat-button
              (click)="openEmailModal()"
              matTooltip="Agregar Email"
              >
              <mat-icon svgIcon="heroicons_solid:plus-circle"></mat-icon>
              <span></span>
            </button>
          </div> -->
            <div class="table-container">
              <table mat-table [dataSource]="currentUpdateCompany.emails">
                <!-- Define columns here -->
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef>Correo Electrónico</th>
                  <td mat-cell *matCellDef="let email">{{ email.email }}</td>
                </ng-container>
                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let email" class="px-6 text-left">
                    <mat-slide-toggle [checked]="email.statusId === 1"
                      [disabled]="!(contactDataTabPermissions.UPDATE | hasPermission)"
                      (change)="onStatusChangeEmail($event.checked, email)" color="primary">
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <button *canPermissionsOnly="contactDataTabPermissions.CREATE" color="primary" mat-button (click)="openEmailModal()"
                      matTooltip="Agregar correo electrónico ">
                      <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                      <span></span>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let email">
                    <div class="button-container">
                      <button *canPermissionsOnly="contactDataTabPermissions.UPDATE" mat-icon-button (click)="openEmailModal(email)" matTooltip="Editar Registro">
                        <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      </button>
                      <button *canPermissionsOnly="contactDataTabPermissions.DELETE" mat-icon-button (click)="openDeleteEmail(email)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsEmail"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsEmail"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Cloud Sales Mobile">
            <mat-tab-group>
              <mat-tab label="Rutero">
                <form #permissionsForm="ngForm">
                  <h3 class="mb-4">Gestión de Permisos</h3>
                  <div class="grid grid-cols-1 gap-4">
                    <div class="mb-4">
                      <app-toggle-option
                        title="Ver nombre legal"
                        description="¿Permite ver nombre legal?"
                        icon="badge"
                        iconColor="blue"
                        [(ngModel)]="permissionsMap.name">
                      </app-toggle-option>
                    </div>

                    <div class="mb-4">
                      <app-toggle-option
                        title="Ver nombre comercial"
                        description="¿Permite ver nombre comercial?"
                        icon="store"
                        iconColor="green"
                        [(ngModel)]="permissionsMap.commercialName"
                        name="commercialName">
                      </app-toggle-option>
                    </div>

                    <div class="mb-4">
                      <app-toggle-option
                        title="Ver DNI"
                        description="¿Permitir ver DNI?"
                        icon="fingerprint"
                        iconColor="purple"
                        [(ngModel)]="permissionsMap.dni"
                        name="dni">
                      </app-toggle-option>
                    </div>

                    <div class="mb-4">
                      <app-toggle-option
                        title="Ver RTN"
                        description="¿Permitir ver RTN?"
                        icon="contact_page"
                        iconColor="orange"
                        [(ngModel)]="permissionsMap.rtn"
                        name="rtn">
                      </app-toggle-option>
                    </div>

                    <div class="mb-4">
                      <app-toggle-option
                        title="Ver dirección"
                        description="¿Permitir ver dirección?"
                        icon="location_city"
                        iconColor="red"
                        [(ngModel)]="permissionsMap.address"
                        name="address">
                      </app-toggle-option>
                    </div>
                  </div>
                </form>

              </mat-tab>
              <mat-tab label="Configuración">
                <form #createForm="ngForm">
                  <h3>Ruteo</h3>
                  <div class="grid grid-cols-2 gap-4 col-span-2 mt-2">
                    <div class="col-span-1">
                      <app-toggle-option
                        title="Validar stock en ruta"
                        description="Habilitar validación de stock durante el ruteo"
                        icon="inventory_2"
                        iconColor="orange"
                        [(ngModel)]="currentUpdateCompany.validateStockInRouting"
                        name="validateStockInRouting">
                      </app-toggle-option>
                    </div>
                    <div class="col-span-1">
                      <app-toggle-option
                        title="Agrupar stock por fecha"
                        description="Agrupar inventario por fecha en ruteo"
                        icon="date_range"
                        iconColor="blue"
                        [(ngModel)]="currentUpdateCompany.groupStockByDateInRouting"
                        name="groupStockByDateInRouting">
                      </app-toggle-option>
                    </div>
                    @if(currentUpdateCompany.groupStockByDateInRouting){
                    <mat-form-field  class="col-span-1">
                      <mat-label>Total Meses</mat-label>
                      <input type="number" matInput [(ngModel)]="currentUpdateCompany.totalMonthsToGroupStockInRouting"
                        name="totalMonthsToGroupStockInRouting" />
                    </mat-form-field>
                    <mat-form-field  class="col-span-1">
                      <mat-label>Segmentación de Meses</mat-label>
                      <input type="number" matInput [(ngModel)]="currentUpdateCompany.monthsToGroupStockInRouting"
                        name="monthsToGroupStockInRouting" />
                    </mat-form-field>
                    }
                  </div>

                  <div class="bg-white p-4 rounded-lg border border-gray-200 mt-6">
                    <h3 class="text-lg font-semibold mb-4 text-gray-800">Horario de toma de pedidos en preventa</h3>
                    <p class="mb-5 text-xs text-gray-600 md:text-sm">
                      Restringe la toma de pedidos en preventa desde la app móvil a una ventana horaria.
                    </p>

                    <mat-form-field class="w-full">
                      <mat-label>Modo de validación del horario de preventa</mat-label>
                      <mat-select [(ngModel)]="currentUpdateCompany.preSaleOrderScheduleEnabled"
                        name="preSaleOrderScheduleEnabled">
                        @for (opt of preSaleOrderScheduleModeOptions; track opt.value) {
                        <mat-option [value]="opt.value">
                          {{ opt.label }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <div class="mt-4 border-t border-gray-200 pt-3">
                      <div class="mt-3 flex flex-col gap-4 sm:flex-row">
                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Hora de inicio</mat-label>
                          <mat-icon matSuffix>schedule</mat-icon>
                          <input matInput [(ngModel)]="currentUpdateCompany.preSaleOrderStartTime"
                            name="preSaleOrderStartTime" [ngxTimepicker]="preSaleStartPickerUpd" [format]="12"
                            [disabled]="!preSaleScheduleEnabledUpdate"
                            [errorStateMatcher]="preSaleStartErrorMatcherUpdate" />
                          <ngx-material-timepicker #preSaleStartPickerUpd [format]="12"
                            (timeSet)="onPreSaleTimeSet('update', 'start', $event)"></ngx-material-timepicker>
                          <mat-error *ngIf="preSaleScheduleEnabledUpdate && !currentUpdateCompany.preSaleOrderStartTime">
                            La hora de inicio es obligatoria
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Hora de fin</mat-label>
                          <mat-icon matSuffix>schedule</mat-icon>
                          <input matInput [(ngModel)]="currentUpdateCompany.preSaleOrderEndTime"
                            name="preSaleOrderEndTime" [ngxTimepicker]="preSaleEndPickerUpd" [format]="12"
                            [disabled]="!preSaleScheduleEnabledUpdate"
                            [errorStateMatcher]="preSaleEndErrorMatcherUpdate" />
                          <ngx-material-timepicker #preSaleEndPickerUpd [format]="12"
                            (timeSet)="onPreSaleTimeSet('update', 'end', $event)"></ngx-material-timepicker>
                          <mat-error *ngIf="preSaleScheduleEnabledUpdate && !currentUpdateCompany.preSaleOrderEndTime">
                            La hora de fin es obligatoria
                          </mat-error>
                          <mat-error *ngIf="preSaleRangeErrorUpdate">
                            La hora de inicio debe ser anterior a la hora de fin
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="col-span-4 mt-6">
                    <div class="w-full">
                      <app-toggle-option
                        title="Validación GPS"
                        description="¿Se valida el GPS en las rutas?"
                        icon="location_on"
                        iconColor="red"
                        [(ngModel)]="currentUpdateCompany.useGPSInCSMmobile"
                        name="useGPSInCSMmobile">
                      </app-toggle-option>
                    </div>
                    @if (currentUpdateCompany.useGPSInCSMmobile) {
                    <div class="mt-4 border-t border-gray-200 pt-3">
                      <div class="mt-3 flex flex-col gap-4 sm:flex-row">
                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Modo de validación GPS</mat-label>
                          <mat-select [(ngModel)]="currentUpdateCompany.useGpsMode" name="useGpsMode">
                            @for (mode of useGpsList; track mode.value) {
                            <mat-option [value]="mode.value">
                              {{ mode.key | transloco }}
                            </mat-option>
                            }
                          </mat-select>
                          <mat-hint>Se aplica a las rutas configuradas como "De acuerdo a compañía"</mat-hint>
                        </mat-form-field>
                        <mat-form-field class="w-full sm:flex-1">
                          <mat-label>Distancia a validar entre el vendedor y cliente (km)</mat-label>
                          <input type="number" matInput
                            [(ngModel)]="currentUpdateCompany.distanceBetween.sellerToCustomer"
                            name="sellerToCustomer" />
                          <mat-suffix>km</mat-suffix>
                        </mat-form-field>
                      </div>
                    </div>
                    }
                  </div>

                  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 col-span-4 mt-6">
                    <div class="col-span-1">
                      <app-toggle-option
                        title="Purgado de viaje"
                        description="Habilitar purgado de viaje (Total/Parcial) y liberación de pedido"
                        icon="refresh"
                        iconColor="purple"
                        [(ngModel)]="currentUpdateCompany.isAvailableTripPurge"
                        name="isAvailableTripPurge">
                      </app-toggle-option>
                    </div>
                    <div class="col-span-1">
                      <mat-form-field class="w-full">
                        <mat-label>Modo de determinación de condiciones comerciales</mat-label>
                        <mat-select [(ngModel)]="currentUpdateCompany.commercialConditionMode" name="commercialConditionMode">
                          @for (mode of commercialConditionModeList; track mode.value) {
                          <mat-option [value]="mode.value">
                            {{ mode.label }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="grid grid-cols-2 gap-4 col-span-4 mt-6">
                    <mat-form-field  class="w-full">
                      <mat-label>Clase de documento para Merma (Por defecto)</mat-label>
                      <mat-select [(ngModel)]="currentUpdateCompany.documentClassToWaste" 
                        [compareWith]="compareById"
                        name="documentClassToWaste">
                        @for (item of filteredDocumentClassList; track item) {
                        <mat-option [value]="item">
                          <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field  class="w-full">
                      <mat-label> Clase de documento para devoluciones(Por defecto)</mat-label>
                      <mat-select [(ngModel)]="currentUpdateCompany.documentClassToReturn"
                        name="documentClassToReturn"
                        [compareWith]="compareById">
                        @for (item of filteredDocumentClassListReturn; track item) {
                        <mat-option [value]="item">
                          <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>


                  <div class="md:flex items-baseline text-center mt-6 col-span-1">
                    <mat-form-field  class="w-full">
                      <mat-label>Tipos de documento que hacen envío automático a ERP al cerrar viaje</mat-label>
                      <mat-select [(ngModel)]="currentUpdateCompany.docTypesToSendToERPatCloseTrip"
                        name="docTypesToSendToERPatCloseTrip">
                        <mat-option>
                          <ngx-mat-select-search [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                            noEntriesFoundLabel="No se encontraron resultados">
                          </ngx-mat-select-search>
                        </mat-option>
                        @for (item of listFilterdocumentTypeList; track item) {
                        <mat-option [value]="item">
                          <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <button mat-icon-button color="primary" class="ml-2 mt-1" (click)="addRelatedDocument()"
                      matTooltip="Agregar tipo de documento" [disabled]="
                                        !currentUpdateCompany.docTypesToSendToERPatCloseTrip ||
                                        currentUpdateCompany.docTypesToSendToERPatCloseTrip.length === 0
                                      ">
                      <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                  </div>
                  <div class="col-span-4" style="max-height: 300px; overflow-y: auto">
                    <table mat-table [dataSource]="dataSourceDocument"
                      class="min-w-500 overflow-y-visible mat-elevation-z">
                      <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef>Código</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element?.code }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element?.name }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element; let i = index">
                          <div class="button-container">
                            <button *canPermissionsOnly="PERMISSIONS.UPDATE" (click)="deleteItem(i)" mat-icon-button>
                              <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                            </button>
                          </div>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumnsDocument" class="sticky top-0 z-10 bg-white">
                      </tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsDocument"></tr>
                    </table>
                  </div>
                </form>
              </mat-tab>
              <mat-tab label="Visualización de materiales">
                <form #createForm="ngForm">
                  <div class="grid grid-cols-2 gap-4 col-span-2 mt-2">
                    <div class="col-span-2">
                      <app-toggle-option
                        title="Configuración de materiales"
                        description="Habilitar Configuración de materiales"
                        icon="view_quilt"
                        iconColor="blue"
                        [(ngModel)]="currentUpdateCompany.useMaterialAppDisplayConfig"
                        name="useMaterialAppDisplayConfig">
                      </app-toggle-option>
                    </div>
                    @if(currentUpdateCompany.useMaterialAppDisplayConfig){
                      <div class="col-span-2">
                        <app-form-section
                          title="Configuración de visualización de materiales"
                          icon="view_quilt"
                          iconColor="blue">

                          <div class="grid gap-6 grid-cols-1 lg:grid-cols-2">
                            <!-- Productos relacionados -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Productos relacionados"
                                description="Mostrar productos relacionados en la aplicación de materiales."
                                icon="widgets"
                                iconColor="indigo"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showRelatedProducts"
                                name="showRelatedProducts">
                              </app-toggle-option>
                            </div>

                            <!-- Código de barras -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Código de barras"
                                description="Mostrar el código de barras de los materiales."
                                icon="qr_code"
                                iconColor="cyan"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showBarcode"
                                name="showBarcode">
                              </app-toggle-option>
                            </div>                  

                            <!-- Cantidad deseada de venta -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Cantidad deseada de venta"
                                description="Mostrar la cantidad deseada de venta."
                                icon="shopping_cart"
                                iconColor="red"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showDesiredSaleQty"
                                name="showDesiredSaleQty">
                              </app-toggle-option>
                            </div>

                            <!-- Precios por corto vencimiento -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Precio por corto vencimiento"
                                description="Mostrar si el producto tiene precios por corto vencimiento."
                                icon="schedule"
                                iconColor="orange"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showShortExpiryPrice"
                                name="showShortExpiryPrice">
                              </app-toggle-option>
                            </div>                  

                            <!-- Cantidad mínima de venta -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Cantidad mínima de venta"
                                description="Mostrar la cantidad mínima de venta permitida."
                                icon="format_list_numbered"
                                iconColor="pink"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showMinimumSale"
                                name="showMinimumSale">
                              </app-toggle-option>
                            </div>

                            <!-- Stock disponible -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Stock disponible"
                                description="Mostrar el stock disponible del material."
                                icon="inventory_2"
                                iconColor="amber"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showStockAvailable"
                                name="showStockAvailable">
                              </app-toggle-option>
                            </div>

                            <!-- Equivalencias de unidad -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Equivalencias de unidad"
                                description="Mostrar equivalencia entre unidad de medida paralela y base o entre unidad de venta y base."
                                icon="swap_horiz"
                                iconColor="teal"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showUnitEquivalence"
                                name="showUnitEquivalence">
                              </app-toggle-option>
                            </div>

                            <!-- Número de destinatarios -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Número de destinatarios"
                                description="Mostrar número de destinatarios (multiplica la cantidad por el número de destinatarios)."
                                icon="groups"
                                iconColor="purple"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showRecipientsCount"
                                name="showRecipientsCount">
                              </app-toggle-option>
                            </div>

                            <!-- Precio por escala -->
                            <div class="w-full">
                              <app-toggle-option
                                title="Precio por escala"
                                description="Mostrar indicador de precios por escala (el precio puede subir o bajar según cantidad)."
                                icon="trending_up"
                                iconColor="green"
                                [(ngModel)]="currentUpdateCompany.materialAppDisplayConfig.showScalePrice"
                                name="showScalePrice">
                              </app-toggle-option>
                            </div>
                          </div>
                        </app-form-section>
                      </div>
                    }
                  </div>
                </form>
              </mat-tab>
            </mat-tab-group>
          </mat-tab>
          <mat-tab label="Finanzas">
            <form #financeEditForm="ngForm">
              <h3 class="col-span-2 mt-4">Configuración de Referencias para Partidas Abiertas</h3>
              <div class="grid grid-cols-1 gap-4 col-span-2 mt-4">
                <div class="flex items-center gap-2">
                  <mat-form-field  class="flex-1">
                    <mat-label>Nr. Nota de crédito para pagos</mat-label>
                    <mat-select [(ngModel)]="currentUpdateCompany.creditNoteField" name="creditNoteField">
                      @for (referenceType of getAvailableReferenceTypes(['creditNoteField']); track referenceType) {
                      <mat-option [value]="referenceType">
                        {{ referenceTypeLabels[referenceType] }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="warn" (click)="clearCreditNoteField()"
                    [disabled]="!currentUpdateCompany.creditNoteField" matTooltip="Limpiar selección">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>

                <div class="flex items-center gap-2">
                  <mat-form-field  class="flex-1">
                    <mat-label>Nr. Anticipo para pagos</mat-label>
                    <mat-select [(ngModel)]="currentUpdateCompany.advancePaymentField" name="advancePaymentField">
                      @for (referenceType of getAvailableReferenceTypes(['advancePaymentField']); track referenceType) {
                      <mat-option [value]="referenceType">
                        {{ referenceTypeLabels[referenceType] }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="warn" (click)="clearAdvancePaymentField()"
                    [disabled]="!currentUpdateCompany.advancePaymentField" matTooltip="Limpiar selección">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>

                <div class="flex items-center gap-2">
                  <mat-form-field  class="flex-1">
                    <mat-label>Siempre se muestra en</mat-label>
                    <mat-select [(ngModel)]="currentUpdateCompany.accountStatementReferenceField"
                      name="accountStatementReferenceField">
                      @for (referenceType of getAvailableReferenceTypes(['accountStatementReferenceField']); track
                      referenceType) {
                      <mat-option [value]="referenceType">
                        {{ referenceTypeLabels[referenceType] }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="warn" (click)="clearAccountStatementReferenceField()"
                    [disabled]="!currentUpdateCompany.accountStatementReferenceField" matTooltip="Limpiar selección">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Carga de datos">
            <div class="py-6">
              <form #loadingAssistantEditForm="ngForm" class="space-y-8 flex flex-col">
                <app-form-section title="Configuración de importación desde Excel" icon="upload_file" iconColor="indigo">
                  <div class="space-y-6">
                    <app-toggle-option
                      [(ngModel)]="currentUpdateCompany.loadingAssistantEnableZeroPadding"
                      name="loadingAssistantEnableZeroPadding"
                      title="Habilitar validación de longitud de códigos"
                      description="Al importar datos desde Excel, se validará que los códigos tengan la cantidad exacta de dígitos configurada"
                      icon="rule"
                      iconColor="indigo"
                      [showExpandedContent]="false">
                    </app-toggle-option>

                    <div *ngIf="currentUpdateCompany.loadingAssistantEnableZeroPadding" class="grid gap-6 grid-cols-1 md:grid-cols-3 mt-6">
                      <mat-form-field  class="w-full">
                        <mat-label>Dígitos totales para materiales</mat-label>
                        <input matInput
                          type="number"
                          [(ngModel)]="currentUpdateCompany.loadingAssistantMaterialZeroPaddingSize"
                          name="loadingAssistantMaterialZeroPaddingSize"
                          min="0"
                          max="20" />
                        <mat-hint>Longitud total del código de materiales en archivo Excel</mat-hint>
                      </mat-form-field>

                      <mat-form-field  class="w-full">
                        <mat-label>Dígitos totales para clientes</mat-label>
                        <input matInput
                          type="number"
                          [(ngModel)]="currentUpdateCompany.loadingAssistantCustomerPaddingSize"
                          name="loadingAssistantCustomerPaddingSize"
                          min="0"
                          max="20" />
                        <mat-hint>Longitud total del código de clientes en archivo Excel</mat-hint>
                      </mat-form-field>

                      <mat-form-field  class="w-full">
                        <mat-label>Dígitos totales para sub-rutas</mat-label>
                        <input matInput
                          type="number"
                          [(ngModel)]="currentUpdateCompany.loadingAssistantSubRoutePaddingSize"
                          name="loadingAssistantSubRoutePaddingSize"
                          min="0"
                          max="20" />
                        <mat-hint>Longitud total del código de sub-rutas en archivo Excel</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </app-form-section>
              </form>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-dialog-content>
      <mat-dialog-actions class="flex justify-between items-center p-6 border-t mt-6">
        <button mat-button mat-dialog-close class="px-6 py-2">Cancelar</button>
      <button mat-raised-button color="primary" (click)="updateCompany(currentUpdateCompany._id)" [disabled]="
          !editForm.valid ||
          isModeDisabled(currentUpdateCompany.businessPartnerCreationMode, currentUpdateCompany)
        " class="px-6 py-2">
        Guardar
      </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <!-- <mat-sidenav
    #sidenav
    mode="side"
    position="end"
    class="mat-sidenav-content p-0"
    closed
  >
    <div class="flex items-center justify-between bg-blue-950 text-white p-4">
      <mat-icon
        svgIcon="filter_list"
        class="text-white mr-2 w-4 h-4"
      ></mat-icon>
      <h2 class="text-current text-lg font-bold">Filtros</h2>
      <button
        mat-icon-button
        class="ml-auto"
        (click)="sidenav.close()"
        matTooltip="Cerrar"
      >
        <mat-icon
          class="text-current"
          [svgIcon]="'heroicons_outline:x-mark'"
        ></mat-icon>
      </button>
    </div> -->

  <!-- Compañía -->
  <!-- <div class="mt-6 px-4">
      <div class="w-full mb-4">
        <label for="company-select" class="block text-gray-700">Compañía</label>
        <ng-select
          [(ngModel)]="selectedCompanyIds"
          [items]="companyList"
          bindLabel="name"
          bindValue="_id"
          [multiple]="true"
          placeholder="Seleccione Compañía"
          [compareWith]="compareById"
          (ngModelChange)="onCompanySelectionChange($event)"
        >
        </ng-select>
      </div>
    </div> -->

  <!-- <div class="flex justify-between mt-4 px-4">
      <button
        mat-button
        class="align-left text-gray-700 border border-gray-300"
        (click)="clearFilters()"
      >
        Limpiar
      </button>
      <button
        mat-raised-button
        class="ml-auto bg-blue-950 text-white"
        (click)="findAllWithCount()"
      >
        Aplicar
      </button>
    </div>
  </mat-sidenav> -->

  <!-- App Filter (vacío - sin filtros disponibles) -->
  <app-filter>
    <div class="flex flex-col items-center justify-center p-8 text-center">
      <mat-icon svgIcon="heroicons_outline:funnel" class="text-gray-400 mb-4" style="width: 64px; height: 64px;"></mat-icon>
      <h3 class="text-lg font-semibold text-gray-700 mb-2">No hay filtros disponibles</h3>
      <p class="text-sm text-gray-500">Esta vista no tiene filtros configurados</p>
    </div>
  </app-filter>

</mat-sidenav-container>